import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import PRCurrentForecastTracker from "./PRCurrentForecastTracker";
import PRPastForecastTracker from "./PRPastForecastTracker";
import { setActiveDataElement } from "../../../redux/userSlice";

const PRDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Production Requirement"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection title="Production Requirement Upload Dashboard" />
            <div className="container">
              {/* top table */}
              <PRCurrentForecastTracker></PRCurrentForecastTracker>
              {/* bottom table */}
              <PRPastForecastTracker></PRPastForecastTracker>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default PRDashboard;
